"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import fetch from "../../util/fetch";
import presenceService from "../presence_service_next_gen";
import Account from "../../api/account";
let nextItem = function rememberNextItem() {
  const rawItem = sessionStorage.getItem("flowmode.nextitem");
  return rawItem ? JSON.parse(rawItem) || null : null;
}();
function saveNextItem(item) {
  if (item) {
    sessionStorage.setItem("flowmode.nextitem", JSON.stringify(item));
  } else {
    sessionStorage.removeItem("flowmode.nextitem");
  }
  nextItem = item;
}
function callVerifyOrFetchNext(data) {
  return fetch("/api/presence/verify_or_fetch_next", {
    data,
    method: "post"
  });
}
export function verifyNextItemOrGetNext(queue, query) {
  return __async(this, null, function* () {
    if (nextItem) {
      console.log("Flow Mode: Verifying next item", { nextItem, time: /* @__PURE__ */ new Date() });
    } else {
      console.log("Flow Mode: Fetching next item", { time: /* @__PURE__ */ new Date() });
    }
    const flowModeQuery = JSON.parse(query.newFlowMode);
    const verified = yield callVerifyOrFetchNext(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, flowModeQuery), {
      queue,
      token: presenceService.token,
      ignoredItems: JSON.parse(sessionStorage.getItem("ignoredItems"))
    }), nextItem && nextItem.lock_canonical_id || {}), nextItem && nextItem.full_id_context && nextItem.full_id_context.exceptionedItemId && { "exceptionedItemId": nextItem.full_id_context.exceptionedItemId } || {}));
    if (nextItem) {
      if (_.isEqual(verified.lock_canonical_id, nextItem.lock_canonical_id)) {
        console.log("Flow Mode: Verified Next Item and locked item is still available", {
          verified,
          time: /* @__PURE__ */ new Date()
        });
      } else {
        console.log("Flow Mode: Locked item is no longer available, new next item", { nextItem: verified, time: /* @__PURE__ */ new Date() });
        saveNextItem(verified);
      }
    } else {
      console.log("Flow Mode: Fetched Next Item", { nextItem: verified, time: /* @__PURE__ */ new Date() });
      saveNextItem(verified);
    }
    return nextItem;
  });
}
export function maybePrefetchNextFlowModeItem(location) {
  return __async(this, null, function* () {
    if (isInNewFlowMode(location.query.onDone) && Account.flowModeEnabled()) {
      console.log("Flow Mode: PREFETCH: Starting", { time: /* @__PURE__ */ new Date() });
      let wait = presenceService.waitForPresence;
      while (wait) {
        console.log("Flow Mode: PREFETCH: ******** Waiting", { time: /* @__PURE__ */ new Date() });
        yield wait;
        wait = wait != presenceService.waitForPresence ? presenceService.waitForPresence : null;
      }
      const flowQuery = new URLSearchParams(decodeURI(location.query.onDone).replace(/.*\?/, ""));
      console.log("Flow Mode: PREFETCH: Calling verifyNextItemOrGetNext", { queue: flowQuery.get("queue"), time: /* @__PURE__ */ new Date() });
      const verifiedOrFetched = yield verifyNextItemOrGetNext(
        flowQuery.get("queue"),
        { newFlowMode: flowQuery.get("newFlowMode") }
      );
      console.log("Flow Mode: PREFETCH: Verified or Fetched", { verifiedOrFetched, time: /* @__PURE__ */ new Date() });
      return verifiedOrFetched;
    } else {
      return null;
    }
  });
}
export function getIgnoredItems() {
  return JSON.parse(sessionStorage.getItem("ignoredItems")) || {};
}
export function addToIgnoredItems(item_type, id) {
  const ignoredItems = getIgnoredItems();
  ignoredItems[item_type] = (ignoredItems[item_type] || []).concat(id);
  sessionStorage.setItem("ignoredItems", JSON.stringify(ignoredItems));
}
export function isInNewFlowMode(onDone) {
  return (onDone || "").startsWith("/flow");
}
export function startNewFlowSession() {
  saveNextItem(null);
  sessionStorage.removeItem("ignoredItems");
  console.log("Flow Mode: starting new flow mode session", { time: /* @__PURE__ */ new Date() });
}
export function usedNextItem() {
  console.log("Flow Mode: clearing nextItem due to flowing to it", { oldNextItem: nextItem, time: /* @__PURE__ */ new Date() });
  saveNextItem(null);
}
